<template>
    <div>
        <div>
            <!-- Voltar conteudo da aula -->
            <div
                class="navigation left"
                v-if="!firstContent && contentList && contentList.data.length > 1"
                @click="!loadedLinks ? $emit('navigate', 'prev'): ''"
                @mouseover="showLeft = true"
                @mouseleave="showLeft = false"
            >
                <i class="navigation-icon fas fa-chevron-left"></i>
            </div>

            <!-- Voltar conteudo anterior (link) -->
            <div
                class="navigation left"
                @mouseenter="handleShow('left')"
                @mouseleave="showLeft = false"
                v-else-if="link.prev"
                @click="$emit('navigateContent', 'prev')"
            >
                <i class="navigation-icon fas fa-chevron-left"></i>
            </div>

            <!-- Avançar conteúdo da aula -->
            <div
                class="navigation right"
                @mouseover="showRight = true"
                @mouseleave="showRight = false"
                v-if="!lastContent && contentList && contentList.data.length > 1"
                @click="$emit('navigate', 'next')"
            >
                <i class="navigation-icon fas fa-chevron-right"></i>
            </div>

            <!-- Avançar próximo conteúdo (link) -->
            <div
                class="navigation right"
                @mouseenter="handleShow('right')"
                @mouseleave="showRight = false"
                type="secondary"
                v-else-if="link.next"
                @click="$emit('navigateContent', 'next')"
            >
                <i class="navigation-icon fas fa-chevron-right"></i>
            </div>

            <FadeTransition>
                <div class="navigation label label-left" v-show="showLeft">{{previousContentName}}</div>
            </FadeTransition>

            <FadeTransition>
                <div class="navigation label label-right" v-show="showRight">{{nextContentName}}</div>
            </FadeTransition>
        </div>
    </div>
</template>

<script>
import { FadeTransition } from 'vue2-transitions';

export default {
    name: 'LessonNavigationContent',

    components: {
        FadeTransition,
    },

    props: {
        color: Object,
        firstContent: Boolean,
        lastContent: Boolean,
        contentList: Object,
        currentContentId: Number,
        parents: Object,
        submodules: Array,
    },
    data() {
        return {
            loadedLinks: false,
            showLeft: false,
            showRight: false,
        };
    },
    computed: {
        link() {
            return this.$store.getters.LOADED_CONTENT_LINKS;
        },
        previousContentName() {
            if (
                !this.firstContent &&
                this.contentList &&
                this.contentList.data &&
                this.contentList.data.length > 1
            ) {
                const currentIndex = this.contentList.data.findIndex(
                    el => el.id === this.currentContentId,
                );
                if (currentIndex > 0) {
                    return this.contentList.data[currentIndex - 1].translation.name;
                }
            }
            if (this.link && this.link.prev) {
                return this.link.prev.name;
            }
            return '';
        },
        nextContentName() {
            if (
                !this.lastContent &&
                this.contentList &&
                this.contentList.data &&
                this.contentList.data.length > 1
            ) {
                const currentIndex = this.contentList.data.findIndex(
                    el => el.id === this.currentContentId,
                );
                if (currentIndex < this.contentList.data.length - 1) {
                    return this.contentList.data[currentIndex + 1].translation.name;
                }
            }
            if (this.link && this.link.next) {
                return this.link.next.name;
            }
            return '';
        },
    },
    methods: {
        /**
         * Hover nas setas: só exibe o rótulo (nome do conteúdo vizinho).
         * Os links já vêm carregados pela aula (Lesson.vue → getLinks no
         * mounted); recarregar a cada mouseenter trocava a seta por um
         * spinner e recriava o ícone sob o cursor — o clique do mouse caía
         * no meio da troca e "não acontecia nada". Só busca se ainda não há
         * links no store, e uma vez por vez.
         */
        handleShow(direction) {
            const show = () => {
                if (direction === 'left') this.showLeft = true;
                else this.showRight = true;
            };
            const hasLinks = this.link && (this.link.prev || this.link.next || this.link.home);
            if (hasLinks || this.loadedLinks) {
                show();
                return;
            }
            this.getLinks().then(show);
        },
        getLinks() {
            this.loadedLinks = true;
            return this.$store
                .dispatch('LOAD_LINKS', {
                    parents: this.parents,
                    submodules: this.submodules,
                })
                .then(() => (this.loadedLinks = false));
        },
    },
};
</script>

<style>
</style>
